<template>
    <div class="social-links">
      <a
        v-for="link in links"
        :key="link.name"
        :href="link.url"
        target="_blank"
        rel="noopener noreferrer"
        class="social-link"
      >
        <i :class="link.icon"></i>
      </a>
    </div>
  </template>
  
  <script>
  export default {
    name: "SocialLinks",
    data() {
      return {
        links: [
          { name: "Facebook", url: "https://facebook.com", icon: "fab fa-facebook" },
          { name: "Twitter", url: "https://twitter.com", icon: "fab fa-twitter" },
          { name: "Instagram", url: "https://instagram.com", icon: "fab fa-instagram" },
          { name: "LinkedIn", url: "https://linkedin.com", icon: "fab fa-linkedin" },
        ],
      };
    },
  };
  </script>
  
  <style scoped>
  .social-links {
  position: fixed;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.social-link {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #008516;
  color: white;
  font-size: 20px;
  text-decoration: none;
  transition: background-color 0.3s, transform 0.3s;
}

.social-link:hover {
  background-color: #008516;
  transform: scale(1.1);
}

/* Hanya tampilkan di mobile */
@media (min-width: 769px) {
  .social-links {
    display: none;
  }
}

@media (max-width: 768px) {
  .social-links {
    right: 5px;
  }

  .social-link {
    width: 35px;
    height: 35px;
    font-size: 18px;
  }
}
  </style>
  